import React from 'react'

const Spinner = () => {
    return (
        <div className="spinner-component">
            <div className="spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    )
}

export default Spinner
